import { render, staticRenderFns } from "./TypeFilter.vue?vue&type=template&id=120fe604&scoped=true"
import script from "./TypeFilter.vue?vue&type=script&lang=js"
export * from "./TypeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120fe604",
  null
  
)

export default component.exports